import React, { useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import SharedOfferBanner from './shared-offer-banner';
import { useTranslation } from 'react-i18next';
import { ISOFFERACTIVE_URL } from '../../services/common/endpoints';
import Loadingcomponent from '../../components/loader/loadingcomponent';
import { RC4Decrypt } from '../../services/common/RC4EncDec';
import MessageModal from '../../components/common/bottom-modal-message';
import { useSelector } from 'react-redux';
import { getformatedMsisdn } from '../../services/common/CommonUtils';
import NoData from '../../components/common/no-data';
import OfferDetail from '../../components/loader/skeletons/common/offer-detail';

const SharedOfferDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const params = useParams();
  const urlParam = RC4Decrypt(params?.offerid);

  const searchParams = new URLSearchParams(urlParam);

  const msisdn = searchParams.get('msisdn');
  const offerid = searchParams.get('offerid');
  const paytype = searchParams.get('paytype');
  const fromPage = searchParams.get('from');

  const customerprofile = useSelector(
    (state) => state?.userdata?.value?.customerprofile
  );
  let loggedInmsisdn = getformatedMsisdn(customerprofile?.Msisdn);

  const {
    data: { data } = {},
    isLoading,
    isFetching,
  } = useQuery(
    [
      'is-offer-active',
      ISOFFERACTIVE_URL.url,
      {
        offerid: offerid,
        mode: 'ff',
        fmsisdn: `965${msisdn}`,
      },
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      staleTime: 0,
      cacheTime: 0,
    }
  );

  const handleBuy = (e) => {
    e.preventDefault();

    if (msisdn !== loggedInmsisdn) {
      toggleModal();
    } else {
      handleRedirect();
    }
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleOk = () => {
    setShowModal(false);
  };

  const defaultState = {
    paytype: paytype,
    offerData: data?.response,
    price: data?.response?.offerbaseprice,
    type: 'rff',
    isfshareoffer: true,
    fulfilment_msisdn: `965${msisdn}`
  }

  const recentPurchaseState = {
    paytype: paytype,
    offerData: data?.response,
    price: data?.response?.offerbaseprice,
  }

  const handleRedirect = () => {
    navigate('/pay', {
      state: fromPage === 'recentpurchase' ? recentPurchaseState : defaultState
    });
  };

  if (isLoading || isFetching) {
    // return <Loadingcomponent />;
    return <OfferDetail longOfferCard={true} bannerHeight="210px" />
  }

  if (data?.status !== '0') {
    return <NoData message='nooffer' />
  }

  return (
    <>
      <div className="pse_sm">
        <SharedOfferBanner data={data} />

        <div className="buy_card flex_grp_align_center">
          <div className="buy_card_info flex_grp_align_center flex1">
            <h3 className="section_title primary_color mb-0">
              {data?.response?.currency || ''}{' '}
              {data?.response?.offerbaseprice || ''}
            </h3>
          </div>
          <div className="buy_card_action">
            <button
              className="custom_btn custom_btn_primary"
              onClick={handleBuy}
            >
              {data?.response?.actiontext}
            </button>
          </div>
        </div>

        <h3 className="section_title mb-4">{data?.response?.title}</h3>
        <h5 className="primary_14 text-uppercase mb-2">{t('details')}</h5>
        <p className="dark_gray_color mb-3 formated-desc">{data?.response?.description}</p>

        {/* {otherOffer?.length > 1 && (
        <>
          <hr className="hr_line"></hr>
          <h3 className="section_title_light mb-4 mt-4">{t('umaylike')}</h3>

          {otherOffer?.splice(0, 3)?.map((offer) => {
            return (
              <div className="mb-3">
                <OfferCardHorizontal
                  offerItem={offer}
                  psmItem={location?.state?.psmItem}
                />
              </div>
            );
          })}
        </>
      )} */}
      </div>

      <MessageModal
        type="10"
        show={showModal}
        toggleModal={toggleModal}
        handleOk={handleOk}
        title={data?.response?.popup?.buyfortext || ''}
        message={
          !data?.response?.metametaList?.ispurchaseallowed
            ? data?.response?.popup?.message
            : ''
        }
        actionText={msisdn}
        handleAction={handleRedirect}
      />
    </>
  );
};
export default SharedOfferDetails;
